import { getAdminAxiosInstance } from "../../../api/Admin";

export const updateYearlyRecap = async (params) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.post(`/recap-theme/store`, params);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};
export const viewYearlyRecap = async (id) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.get(`/recap-theme/edit?id=${id}`);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const getYearlyRecapImage = async (params) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.post(
      `/recap-theme/upload-image`,
      params
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};
export const deleteYearlyRecap = async (userid) => {
  const api = await getAdminAxiosInstance();

  try {
    const response = await api.delete(`/recap-theme/delete?id=${userid}`);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};